import { useState, useEffect } from 'react';
import { loadCategories } from '@/lib/api';

// Same shape the pages expect. Backed by the template /api/categories (string
// category names) mapped to numeric ids in src/lib/api.ts.
export interface Category {
  id: number;
  name: string;
  sort_order: number;
}

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    loadCategories().then((cats) => {
      if (!alive) return;
      setCategories(cats.map((c) => ({ id: c.id, name: c.name, sort_order: c.sort_order })));
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  return { categories, loading };
}
